import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {CommonResponse} from "../../../../shared/response/common.response";
import {UtilityService} from "../../../../shared/services/utility.service";

@Injectable({
    providedIn: 'root'
})
export class ApiTrabajadorRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
        // API_URI = environment.API_URI;
        // PUBLIC_URI = environment.PUBLIC_URI;
    API_URI = this.utilityService.getURLBaseApi();
    PUBLIC_URI = this.utilityService.getURLBasePublic();

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient,
                private utilityService: UtilityService
    ) {
    }

    public async login(credentials: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/login', credentials).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async deleteTokenByToken(token: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/deleteTokenByToken/' + token).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async aceptarTerminosYCondiciones(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'operario/aceptarTerminosCondiciones').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async registrarSintomas(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'controldiario/registrarsintomas', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async registrarSalida(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'asistencia/registrarSalida', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async registrarEntrada(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'asistencia/registrarEntrada', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getDataByDNI(dni): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + `trabajador/getDataByDNI/${dni}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getEstadoCivilList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/getEstadoCivilList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getDocumentos(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/getTiposDocumentos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getGradoInstruccionList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/getGradoInstruccionList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async update(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.PUBLIC_URI + 'trabajador/update', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async registrarSolicitud(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/vacaciones/registrarSolicitud', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getHistorialVacaciones(trabajadorID, pagina, registros, empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + `trabajador/vacaciones/getHistorialPaginate/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getTipocupoDisponible(trabajadorID, empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const url = this.PUBLIC_URI + `trabajador/cupon/getTipocupoDisponible/${trabajadorID}/${empresaId}`;
            const responseSuccess = await this.http.get(url).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async getHistorialCupones(trabajadorID, pagina, registros, empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + `trabajador/cupon/getHistorialPaginate/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async registrarCupon(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/cupon/registrarCupon', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }



    public async getSolicitudes_DescandoMedico(trabajadorID, pagina, registros,
                                               empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI
                + `trabajador/solicitud/getSolicitudPaginate/1/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    /** Historial de permisos del trabajador (solicitud de tipo 2). */
    public async getSolicitudes_Permiso(trabajadorID, pagina, registros,
                                        empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI
                + `trabajador/solicitud/getSolicitudPaginate/2/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async getTiposPermiso(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/solicitud/getTiposPermiso').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    /** Avisos de la pantalla de inicio: documentos por vencer, datos por revisar, pendientes y desempeño. */
    public async getInicioPortal(trabajadorID, empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI
                + `trabajador/portal/inicio/${trabajadorID}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async guardarSolicitud(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI
                + 'trabajador/solicitud/guardarSolicitud', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async getDataSolicitud(solicitudId): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI
                + 'trabajador/solicitud/getDataSolicitud/' + solicitudId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async getHistorialDocumentos(trabajadorID, tipoDoc, pagina, registros,
                                        empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + `trabajador/documentos/getHistorialPaginate/${trabajadorID}/${tipoDoc}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async registrarDocumento(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/documentos/registrar', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async adjuntarArchivo(file: FormData): Promise<CommonResponse> {
        try {
            // tslint:disable-next-line:max-line-length
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/adjuntarArchivo', file).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async guardarFormatoVacaciones(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.PUBLIC_URI + 'trabajador/vacaciones/guardarFormato', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async generarCodigoAcceso(dni, puesto = null): Promise<CommonResponse> {
        try {
            let url = this.PUBLIC_URI + `trabajador/generarCodigoAcceso/${dni}`;

            if (puesto) {
                url += `/${puesto}`;
            }

            const responseSuccess = await this.http.get(url).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    public async validarCodigoAcceso(dni, codigo): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + `trabajador/validarCodigoAcceso/${dni}/${codigo}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }


    public async getHistorialMovilidad(pagina, registros, obj, empresaId = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + `trabajador/movilidad/getHistorialPaginate/${pagina}/${registros}/${empresaId}`, obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async registrarMovilidad(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/movilidad/registrar', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async buscarPorDocumentoMovilidad(numero: string, regimen: string): Promise<CommonResponse> {
        try {
            // tslint:disable-next-line:max-line-length
            const responseSuccess = await this.http.get(`${environment.API_ITURRIAPP}/rest/app/search/getDataByRegimen/${numero}/${regimen}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getConceptosList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(`${environment.API_ITURRIAPP}/rest/app/servicio/byDespachadorList`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    public async eliminarMovilidad(id: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.delete(this.PUBLIC_URI + `trabajador/movilidad/eliminar/${id}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return  this.utilityService.parseData(responseError);
        }
    }

    /**
     * Encuesta de clima laboral: devuelve la campaña vigente y su formulario
     * si el trabajador puede responderla, o el motivo por el que no.
     */
    public async getEncuestaClima(dni: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + `climalaboral/getCampaniaParaTrabajador/${dni}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async registrarEncuestaClima(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'climalaboral/guardarRespuesta', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

}
